<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="TARIFA.SIFRA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtSifra"
              formControlName="Sifra"
              #focusElement
              [MaxLength]="3"
              [ngClass]="{'is-invalid' : submitted && fc.Sifra.invalid}"
              [Label]="'TARIFA.SIFRA.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                  <span *ngFor="let validation of errorMessages.Sifra">
                    <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Naziv"
              [MaxLength]="50"
              [ngClass]="{'is-invalid' : submitted && fc.Naziv.invalid}"
              [Label]="'TARIFA.NAZIV.SINGULAR'">
            </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
              </div>
          </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtUnCode"
                formControlName="UnCode"
                [MaxLength]="2"
                [ngClass]="{'is-invalid' : submitted && fc.UnCode.invalid}"
                [Label]="'TARIFA.UNCODE.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.UnCode.invalid">
                    <span *ngFor="let validation of errorMessages.UnCode">
                      <span class="error-message" *ngIf="fc.UnCode.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <div class="form-group row">
              <div class="col-md-12">
                  <yt-dropdown-picklist
                        [ModelName]="'drzava'"
                        [GetName]="'get'"
                        [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'"
                        [AllowAddNew]="true"
                        formControlName="DrzavaID"
                        [Label]="'TARIFA.DRZAVA.SINGULAR'"
                        >
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.DrzavaID.invalid">
                      <span *ngFor="let validation of errorMessages.DrzavaID">
                        <span class="error-message" *ngIf="fc.DrzavaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
            </div>
          <div class="form-group row">
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtEName"
                  formControlName="EName"
                  [MaxLength]="3"
                  [ngClass]="{'is-invalid' : submitted && fc.EName.invalid}"
                  [Label]="'TARIFA.ENAME.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.EName.invalid">
                      <span *ngFor="let validation of errorMessages.EName">
                        <span class="error-message" *ngIf="fc.EName.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12">
                  <yt-input
                    [Type]="'text'"
                    name="txtETaxTypeCode"
                    formControlName="ETaxTypeCode"
                    [MaxLength]="30"
                    [ngClass]="{'is-invalid' : submitted && fc.ETaxTypeCode.invalid}"
                    [Label]="'TARIFA.ETAXTYPECODE.SINGULAR'">
                  </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.ETaxTypeCode.invalid">
                        <span *ngFor="let validation of errorMessages.ETaxTypeCode">
                          <span class="error-message" *ngIf="fc.ETaxTypeCode.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
              </div>
      </div>
    </div>
  </div>
</form>